import {Icon} from '@components/ui/icon'
import {FC} from 'react'

interface MetricsCardProps {
    title: string
    description: string
    icon: Icon
    value: string
}

export const MetricsCard: FC<MetricsCardProps> = ({title, description, icon: Icon, value}) => {
    return (
        <div className="flex flex-col gap-2 rounded-xl border border-neutral-300 bg-white p-6 shadow-xs">
            <div className="flex w-full items-start gap-5">
                <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                    <p className="text-sm font-medium text-neutral-600">{title}</p>
                    <h3 className="text-display-sm font-medium text-neutral-900">{value}</h3>
                </div>
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-neutral-200 shadow-xs [&_svg]:h-5 [&_svg]:w-5 [&_svg]:text-neutral-700">
                    <Icon />
                </div>
            </div>
            <p className="text-sm font-normal text-neutral-600">{description}</p>
        </div>
    )
}
